import { Box, Button } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  getApprovalListAsync,
  kycApprovalAsync,
} from '../ApprovalStore/approvalSlice';
import useToast from '../../../hooks/useToast';
import useApprovalModal from '../../../hooks/useApprovalModal';
import CloseIcon from '@material-ui/icons/Close';

function SchoolKycModalDetails() {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleCloseApprovalModal } = useApprovalModal();
  const {
    schoolKycDocDetails,
    schoolKycApprovalId,
    schoolKycApprovalStatus,
    schoolKycApiStatus,
    userDetails,
  } = useSelector(({ userKycApproveReducer }) => {
    return {
      schoolKycDocDetails: userKycApproveReducer.schoolKycDocDetails,
      schoolKycApprovalId: userKycApproveReducer.schoolKycApprovalId,
      schoolKycApprovalStatus: userKycApproveReducer.schoolKycApprovalStatus,
      schoolKycApiStatus: userKycApproveReducer.schoolKycApiStatus,
      userDetails: userKycApproveReducer.userDetails,
    };
  });
  const handleApprove = () => {
    dispatch(
      kycApprovalAsync({
        _id: schoolKycApprovalId,
        bodyData: { action: 'approved' },
      })
    )
      .unwrap()
      .then((res) => {
        // console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'kyc',
              approvalType: 'school-kyc-status',
              limit: 10,
              page: 1,
              statuses: [schoolKycApiStatus],
            },
            type: 'schoolKyc',
          })
        );
        SuccessToast('Approved!');
        handleCloseApprovalModal();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleDisapprove = () => {
    dispatch(
      kycApprovalAsync({
        _id: schoolKycApprovalId,
        bodyData: { action: 'rejected' },
      })
    )
      .unwrap()
      .then((res) => {
        // console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'kyc',
              approvalType: 'school-kyc-status',
              limit: 10,
              page: 1,
              statuses: [schoolKycApiStatus],
            },
            type: 'schoolKyc',
          })
        );
        SuccessToast('Disapproved!');
        handleCloseApprovalModal();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  return (
    <Box
      px={8}
      py={6}
      bgcolor="white"
      fontFamily={'Rubik'}
      width="80vw"
      height={'80vh'}
      sx={{ overflowY: 'scroll' }}>
      {schoolKycDocDetails ? (
        <>
          <Box
            pb={2}
            borderBottom={`1px solid #dfdfdf`}
            mb={3}
            display="flex"
            width={'100%'}
            justifyContent="space-between">
            <Box fontSize={20} fontWeight="fontWeightMedium">
              School KYC
            </Box>
            <Box sx={{ cursor: 'pointer' }}>
              <CloseIcon fontSize="large" onClick={handleCloseApprovalModal} />
            </Box>
          </Box>
          {userDetails && (
            <Box mb={6} display="flex" justifyContent={'space-between'}>
              <Box>
                <Box
                  fontSize={20}
                  fontWeight="fontWeightMedium"
                  mb={2}
                  sx={{ textDecoration: 'underline' }}>
                  User Details
                </Box>
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    User Name:
                  </Box>
                  <Box fontSize={16}>{userDetails.name}</Box>
                </Box>
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    Email:
                  </Box>
                  <Box fontSize={16}>{userDetails.email}</Box>
                </Box>
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    Mobile:
                  </Box>
                  <Box fontSize={16}>{userDetails.mobile}</Box>
                </Box>
                <Box display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    User ID:
                  </Box>
                  <Box fontSize={16}>{userDetails._id}</Box>
                </Box>
              </Box>
              <Box>
                <Box
                  fontSize={20}
                  fontWeight="fontWeightMedium"
                  mb={2}
                  sx={{ textDecoration: 'underline' }}>
                  Current Owner Details
                </Box>
                {schoolKycDocDetails && schoolKycDocDetails.currentOwner && (
                  <>
                    <Box mb={2} display={'flex'}>
                      <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                        Name:
                      </Box>
                      <Box fontSize={16}>
                        {schoolKycDocDetails.currentOwner.name}
                      </Box>
                    </Box>
                    <Box mb={2} display={'flex'}>
                      <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                        Email:
                      </Box>
                      <Box fontSize={16}>
                        {schoolKycDocDetails.currentOwner.email}
                      </Box>
                    </Box>
                    {/* <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    Mobile:
                  </Box>
                  <Box fontSize={16}>**TODO</Box>
                </Box> */}
                    <Box mb={2} display={'flex'}>
                      <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                        User ID:
                      </Box>
                      <Box fontSize={16}>
                        {schoolKycDocDetails.currentOwner._id}
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          )}
          <Box
            fontSize={20}
            fontWeight="fontWeightMedium"
            mb={2}
            sx={{ textDecoration: 'underline' }}>
            School KYC Information
          </Box>
          <Box borderBottom={'1px solid #dfdfdf'} pb={2} mb={2}>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                School Name:
              </Box>
              <Box fontSize={16}>
                {schoolKycDocDetails &&
                  schoolKycDocDetails.school &&
                  schoolKycDocDetails.school.schoolName}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Organization Type:
              </Box>
              <Box fontSize={16}>
                {schoolKycDocDetails &&
                  schoolKycDocDetails.kyc &&
                  schoolKycDocDetails.kyc.schoolKyc &&
                  schoolKycDocDetails.kyc.schoolKyc.organizationType}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Status:
              </Box>
              <Box fontSize={16}>
                {schoolKycDocDetails &&
                  schoolKycDocDetails.kyc &&
                  schoolKycDocDetails.kyc.status}
              </Box>
            </Box>
            {schoolKycDocDetails &&
              schoolKycDocDetails.kyc &&
              schoolKycDocDetails.kyc.schoolKyc.documents.map((item) => (
                <Box mb={2} key={item} display="flex">
                  <Box display={'flex'} mr={6}>
                    <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                      Document type:
                    </Box>
                    <Box fontSize={16}>{item.documentType}</Box>
                  </Box>
                  <Box display={'flex'}>
                    <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                      Document:
                    </Box>
                    <Box fontSize={16}>
                      <a
                        style={{ color: 'black' }}
                        href={item.document}
                        target="_blank"
                        rel="noreferrer">
                        See Document
                      </a>
                    </Box>
                  </Box>
                </Box>
              ))}
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Pancard Document:
              </Box>
              <Box fontSize={16}>
                <a
                  style={{ color: 'black' }}
                  href={
                    schoolKycDocDetails &&
                    schoolKycDocDetails.kyc &&
                    schoolKycDocDetails.kyc.schoolKyc &&
                    schoolKycDocDetails.kyc.schoolKyc.panCardDocument
                  }
                  target="_blank"
                  rel="noreferrer">
                  See Pancard Document
                </a>
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Authorized Document:
              </Box>
              <Box fontSize={16}>
                <a
                  style={{ color: 'black' }}
                  href={
                    schoolKycDocDetails &&
                    schoolKycDocDetails.kyc &&
                    schoolKycDocDetails.kyc.schoolKyc &&
                    schoolKycDocDetails.kyc.schoolKyc.authorizedPersonDocument
                  }
                  target="_blank"
                  rel="noreferrer">
                  See Authorized Document
                </a>
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Created at:
              </Box>
              <Box fontSize={16}>
                {moment(
                  schoolKycDocDetails &&
                    schoolKycDocDetails.kyc &&
                    schoolKycDocDetails.kyc.createdAt
                ).format('MMMM Do, YYYY')}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Updated at:
              </Box>
              <Box fontSize={16}>
                {moment(
                  schoolKycDocDetails &&
                    schoolKycDocDetails.kyc &&
                    schoolKycDocDetails.kyc.updatedAt
                ).format('MMMM Do, YYYY')}
              </Box>
            </Box>
          </Box>
          <Box width={'100%'} display="flex" justifyContent={'flex-end'}>
            <Box mr={2}>
              <Button
                disabled={schoolKycApprovalStatus === 'approve'}
                onClick={handleDisapprove}
                variant="outlined"
                color="primary">
                Disapprove
              </Button>
            </Box>
            <Box>
              <Button
                disabled={schoolKycApprovalStatus === 'approve'}
                onClick={handleApprove}
                variant="contained"
                color="primary">
                Approve
              </Button>
            </Box>
          </Box>
        </>
      ) : null}
    </Box>
  );
}

export default SchoolKycModalDetails;
